export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href = 'https://docs.microsoft.com/en-us/microsoft-365/compliance/turn-audit-log-search-on-or-off';
